import { WebPortalClientConfigV1Schema } from '@csp/config-schemas';
import { Maybe, WebPortalClientConfig } from '@csp/csp-common-model';
import { JsonValidationService } from '@csp/csp-common-util';
import { WebPortalClientConfigV1 } from '@csp/config-schemas/src/lib/client/model/generated/WebPortalClientConfigV1';

export const DEFAULT_MINUTES_TO_LOGOUT = 60;

const toWebPortalClientConfig = (webPortalClientConfigV1: Maybe<WebPortalClientConfigV1>): WebPortalClientConfig => {
  if (webPortalClientConfigV1) {
    JsonValidationService.validateJsonNonStrict(
      'WebPortalClientConfig.json',
      WebPortalClientConfigV1Schema,
      webPortalClientConfigV1,
    );
  }

  return {
    minutesIdleToAutoLogout: webPortalClientConfigV1?.minutesIdleToAutoLogout ?? DEFAULT_MINUTES_TO_LOGOUT,
  };
};

export const WebPortalClientConfigService = {
  toWebPortalClientConfig,
};
